// src/config.js

// エックスサーバー用 APIの宛先
export const API_URL = "https://japantv00.xsrv.jp/api/attendance_api.php";